import React, { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import useForm from "../../hooks/useForm";
import LoginInput from "../../components/Form/LoginInput";
import LoginButton from "../../components/Form/LoginButton";
import facebookIcon from "../../assets/Icons/facebook.svg";
import googleIcon from "../../assets/Icons/google.svg";
import appleIcon from "../../assets/Icons/apple.svg";
import blueBg from "../../assets/Login/bluebg.svg";
import loginImage from "../../assets/Login/image1.png";
import LoginImageMobile from "../../assets/Login/mobilebg.svg";
import LoginImageTab from "../../assets/Login/bluebg-tabs.png";
import { replace, useNavigate, useSearchParams } from "react-router-dom";
import { useThunk } from "../../hooks/useThunk";
import { changePassword, verifyPasswordForgot } from "../../store";
import showToast from "../../utils/toastNotifications";
import { errorMessages } from "../../constants/frontendErrorMessages";
import { USER_INPUT_FIELD_TYPES } from "../../constants/userInputFieldNames";
import { getGoogleAuthUrl } from "../../utils/googleAuth";
import ButtonSpinner from "../../components/loading/ButtonSpinner";

const NewPassword = () => {


  const [linkVerified, setLinkVerified] = useState(true)
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [verifyError, setVerifyError] = useState(null)
  const navigate = useNavigate();
  const [doVerifyPasswordForgot, isVerifying] = useThunk(verifyPasswordForgot)
  const [doChangePassword, isPasswordChanging] = useThunk(changePassword)
  const [searchParams, setSearchParam] = useSearchParams();

  const token = searchParams.get("token");
  const id = searchParams.get("id")

  const {
    formData,
    errors,
    touched,
    handleInputChange,
    handleBlur,
    validateForm,
    setTouched,
  } = useForm({
    password: "",
    confirmPassword: "",
  },
  {
    password: true,
    confirmPassword: true
  },
  {
    password: USER_INPUT_FIELD_TYPES.PASSWORD,
    confirmPassword: USER_INPUT_FIELD_TYPES.CONFIRM_PASSWORD
  }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    setTouched({
      password: true,
      confirmPassword: true,
    });

    if (validateForm()) {
      //form submission
      console.log("Password Updated:", formData);

      const result = await doChangePassword({token, id, data: formData})
      
      if(result.success){
        navigate("/signin", {replace: true})
        showToast("success", result.response?.message)
      }else{
        showToast("error", result.error?.message)
      }
    }
  };
  
  const handleOkayButton = () => {
    navigate("/forgot-password", {replace: true})
  } 

  // redirect user to google concent screen
  const handleGoogleSignin = (e) => {
    e.preventDefault();
    const authUrl = getGoogleAuthUrl();
    if(!authUrl){
      showToast("error", errorMessages.FAILED_GOOGLE_SIGNIN)
      return
    }
    window.location.href = authUrl
  }

  useEffect(() => {

    if(!token || !id){
      setLinkVerified(false)
      setVerifyError(errorMessages.FAILED_RESET_PASSWORD);
      return
    }
    // check if user has valid link to change the password with a backend call
    doVerifyPasswordForgot({id, token})
      
      .then((result) => {
        
        if(result.success){
          setLinkVerified(true)

        }else{
          setLinkVerified(false);
          setVerifyError(result.error.message)
        }
      })

  },[id, token, doVerifyPasswordForgot])

  return (

    <div>

    {/* <<<=== spinner with loading dialog box while link is verifying ===>>> */}
      {isVerifying &&
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow-lg w-96 p-5">
          <h2 className="text-xl font-bold text-blue-shades">Verifying Link...</h2>
          <div className="flex items-center justify-center mt-4">
            <div className="loader border-t-4 border-blue-shades rounded-full w-10 h-10 animate-spin"></div>
          </div>
          <p className="mt-4 text-gray-700">Please wait while we verify your password reset link.</p>
        </div>
      </div>
      }

      {/* Invalid Link notify Dialog Box */}
      { !linkVerified && !isVerifying &&
      <div>
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg shadow-lg w-96 p-5">
              <h2 className="text-xl font-bold text-primary">Invalid Link</h2>
              <p className="mt-2 text-gray-700">
                {verifyError}. Please request a new Link.
              </p>
              <div className="mt-4 flex justify-end">
                <button
                  className="px-4 py-2 bg-primary text-white rounded hover:bg-blue-shades"
                  onClick={handleOkayButton}
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
        
      </div>
      }

      {/* component */}
      <div className={`flex flex-col min-w-[403px] relative w-full  overflow-x-hidden h-screen ${!linkVerified || isVerifying ? "blur-sm" : ""}`}>
        {/* WatermarkBg*/}
        <div className="lg:hidden absolute right-0 w-[60%]">
          <img
            src={LoginImageMobile}
            alt="background"
            className="sm:hidden w-full"
          />
          <img
            src={LoginImageTab}
            alt="background"
            className="hidden sm:block w-full ml-[40px] pl-8"
          />
        </div>

        <div className="absolute z-0 top-0 right-0 w-full login-br:block">
          <img
            src={blueBg}
            alt="background"
            className="hidden lg:block absolute -right-15 -top-20 lg:right-0 w-full  lg:max-w-[700px] xl:max-w-[750px] 2xl:max-w-[800px] 1920-br:max-w-[850px] 2560-br:max-w-[1400px] transition-all duration-300"
          />
        </div>

        {/* Form Container-left  */}
        <div className="relative z-10 mx-auto mt-20 mb-0 sm:mt-16 pb-10 flex flex-grow items-start lg:items-center justify-center login-br:justify-between w-full 2xl:max-w-[1536px] auth-layout-structure-in-tab-screen-higher-than-880-height">
          <div className="w-full lg:w-[90%] 2xl:w-[60%] flex flex-col justify-center px-10 lg:px-20 ml-0 1920-br:translate-x-[80px]">
            <h1 className="w-[40%] md:w-[30%] xl:w-full text-level-1 font-roboto font-bold leading-[44px] text-primary mb-2 sm:mb-4">
              Reset Password
            </h1>
            <p className="mb-0 sm:mb-10 font-inter text-[18px] text-gray max-w-[200px] sm:max-w-[360px] md:max-w-[300px]  xl:max-w-none">
              Please enter your new password to continue
            </p>

            <form
              onSubmit={handleSubmit}
              className="w-full sm:max-lg:w-[55%] max-sm:mt-20"
            >
              <div>
                <div className="grid grid-cols-1 md:gap-1 lg:mr-12 xl:mr-36 ">
                  {/* Password Input */}
                  <LoginInput
                    className="signup-password-toogle w-full 2xl:w-full px-4"
                    id="password"
                    name="password"
                    label="New Password"
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    placeholder="Enter your new password"
                    error={touched.password && errors.password}
                    showPasswordToggle
                    isPasswordVisible={showPassword}
                    togglePasswordVisibility={() =>
                      setShowPassword(!showPassword)
                    }
                    onChange={(e) =>
                      handleInputChange("password", e.target.value)
                    }
                    onBlur={() => handleBlur("password", formData.password)}
                  />

                  {/* Confirm Password Input */}
                  <LoginInput
                    className="signup-password-toggle w-full 2xl:w-full px-4 "
                    id="confirmPassword"
                    name="confirmPassword"
                    label="Re-Enter New Password"
                    type={showConfirmPassword ? "text" : "password"}
                    value={formData.confirmPassword}
                    placeholder="Re-enter your new password"
                    error={touched.confirmPassword && errors.confirmPassword}
                    showPasswordToggle
                    isPasswordVisible={showConfirmPassword}
                    togglePasswordVisibility={() =>
                      setShowConfirmPassword(!showConfirmPassword)
                    }
                    onChange={(e) =>
                      handleInputChange("confirmPassword", e.target.value)
                    }
                    onBlur={() => handleBlur("confirmPassword", formData.confirmPassword)}
                  />
                </div>
              </div>

              <div className="flex flex-col items-center justify-center mt-14 lg:mr-12 xl:mr-36 ">
                {/* Sign In Button */}
                <LoginButton
                  text= {
                    isPasswordChanging ? 
                    <ClipLoader
                      loading={true}
                      speedMultiplier={0.5}
                      size={22}
                      color="#60a5fa"
                    />
                    : "Reset Password"
                  }
                  type="submit"
                  disabled={isPasswordChanging}
                  className="w-full py-3 h-[54px] "
                />
                {/* Sign Up Link */}
                <p className="mt-3  font-lato text-[15px] text-center leading-[18.75px] text-black/50">
                  Don’t have an account?{" "}
                  <a href="/signup" className="text-blue-shades hover:underline">
                    Sign Up
                  </a>
                </p>
                {/* social logins */}
                <div className="flex mt-8 w-full ">
                  <div className="w-full ">
                    <div className="relative">
                      <div className="absolute inset-0 flex items-center">
                        <div className="w-full border-t border-medium-gray"></div>
                      </div>
                      <div className="relative flex justify-center text-sm">
                        <span className="px-2 font-inter font-medium text-level-3 leading-[24px] text-gray bg-white">
                          or
                        </span>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 h-[54px] gap-4 mt-6">
                      {/* <button 
                        className="flex items-center justify-center px-4 py-2 border rounded-md border-medium-gray hover:bg-gray-50"
                        disabled={isPasswordChanging}>
                        
                        <img
                          src={facebookIcon}
                          alt="Facebook"
                          className="w-5 h-5"
                        />
                      </button> */}
                     <button
                      className="flex items-center justify-center gap-3 font-inter font-semibold text-[18px] leading-[21.6px] text-gray py-3 rounded-lg hover:bg-[#EFEFEF] transition duration-200 px-4 py-2 border rounded-md border-medium-gray "
                      onClick={handleGoogleSignin}
                      disabled={isPasswordChanging}
                    >
                      <img src={googleIcon} alt="Google" className="w-5 h-5" />
                      <span>Continue with Google</span>
                    </button>
                      {/* <button 
                        className="flex items-center justify-center px-4 py-2 border rounded-md border-medium-gray hover:bg-gray-50"
                        disabled={isPasswordChanging}>
                        <img src={appleIcon} alt="Apple" className="w-5 h-5" />
                      </button> */}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          {/* Right Side: Image */}
          <div className="hidden lg:flex items-center justify-center w-full md:max-w-[480px] lg:max-w-[580px] xl:max-w-[650px] 1920-br:-translate-x-[80px]">
            <img src={loginImage} alt="Sign Up" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPassword;
